export const PopupShowOnType = Object.freeze({
    OnClick: 'onClick',
    OnHover: 'onHover',
    OnFieldFocus: 'onFieldFocus',
});

